module.exports = __webpack_public_path__ + "static/media/bars.59f4b3d8.svg";